import { render } from "./TheProgram.vue?vue&type=template&id=252e75ba"
import script from "./TheProgram.vue?vue&type=script&lang=js"
export * from "./TheProgram.vue?vue&type=script&lang=js"

import "./TheProgram.vue?vue&type=style&index=0&id=252e75ba&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__